/**
 * @generated SignedSource<<87ac672340e968b90dc12d923ae42c32>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type salesOrderFragment$data = {
  readonly salesOrderItems: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"salesOrderItemFragment">;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"salesOrderBaseFragment" | "salesOrderAmountFragment" | "salesOrderPaymentsFragment">;
  readonly " $fragmentType": "salesOrderFragment";
};
export type salesOrderFragment$key = {
  readonly " $data"?: salesOrderFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"salesOrderFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "salesOrderFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "salesOrderBaseFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "salesOrderAmountFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "salesOrderPaymentsFragment"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SalesOrderItem",
      "kind": "LinkedField",
      "name": "salesOrderItems",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "salesOrderItemFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SalesOrder",
  "abstractKey": null
};

(node as any).hash = "46ea557ca781c157ab7707ccf2f261ea";

export default node;
